import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./CourseFormModal.scss";
import { Formik, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
//Components
import Input from "../Inputs/Input";
import CustomSelect from "../Inputs/CustomSelect";
import LoaderDots from "../../generalComponents/LoaderDots";
import AlertPopUp from "../../generalComponents/AlertPopUp";

import {
  removeCourseFromUpdating,
  updateCourse,
} from "../../../actions/course";
import { closeModal } from "../../../actions/ui";
import { getColleges } from "../../../actions/college";
const CourseFormModal = () => {
  const dispatch = useDispatch();

  const courseToUpdate = useSelector((state) => state.courses.courseToUpdate);
  const { msgAlert } = useSelector((state) => state.alert);
  const { loading } = useSelector((state) => state.ui);

  const { colleges } = useSelector((state) => state.colleges);

  const { college, name, duration, material, tuitionfee, applicationfee } =
    courseToUpdate;

  useEffect(() => {
    dispatch(getColleges());

    //eslint-disable-next-line
  }, []);

  const collegeLocations = () => {
    const college = colleges.filter(
      (el) => el.name === courseToUpdate.college.name
    );
    return college[0]?.location;
  };

  const campus = collegeLocations();

  const initialValues = {
    college: college,
    name: name,
    duration: duration,
    campus: campus,
    material: material,
    tuitionfee: tuitionfee,
    applicationfee: applicationfee,
  };

  const formValues = courseToUpdate;

  const courseSchema = Yup.object().shape({
    name: Yup.string().required("Name is required"),
    duration: Yup.number()
      .required("Duration is required")
      .min(1, "Invalid Number"),
    campus: Yup.array().min(1, "Select at least one option"),
    material: Yup.number()
      .required("Material is required")
      .min(0, "Invalid Number"),
    tuitionfee: Yup.number()
      .required("Tuition is required")
      .min(0, "Invalid Number"),
    applicationfee: Yup.number()
      .required("Application Fee is required")
      .min(0, "Invalid Number"),
  });

  const handleFromikSubmit = (values) => {
    const courseUpdate = {
      ...courseToUpdate,
      ...values,
    };

    dispatch(updateCourse(courseUpdate));

    setTimeout(() => {
      dispatch(removeCourseFromUpdating());
      dispatch(closeModal());
    }, [1000]);
  };

  return (
    <div className="">
      <Formik
        initialValues={initialValues}
        validationSchema={courseSchema}
        onSubmit={handleFromikSubmit}
        enableReinitialize
      >
        {({ values, setFieldValue }) => {
          const valueCampus = values.campus;

          return (
            <div className="form-course-modal__wrapper">
              <div className="form-course-modal__container">
                <Form>
                  <div className="section-course-modal-select">
                    <label className="title-gray-black-18">College:</label>
                    <div className="modal-select__name">
                      <h2 className="title-gray-black-18 modal-select__name--active">
                        {courseToUpdate.college.name}
                      </h2>
                    </div>
                  </div>
                  <Input name="name" label="Name:" isModal={true} />

                  <Input
                    name="duration"
                    type="number"
                    label="Duration (Weeks):"
                    isModal={true}
                  />

                  <div className="section-campus-modal-select">
                    <label htmlFor="campus" className="title-gray-black-18">
                      CAMPUS:
                    </label>

                    <CustomSelect
                      className={`custom-modal-select`}
                      // options={formValues.campus} //<-los valores del colegio actual
                      options={initialValues.campus} //<-los valores del college actual <- Este sirve mas
                      value={valueCampus}
                      onChange={(value) => setFieldValue("campus", value)}
                      editingEvent={true}
                      editingOptions={formValues.campus} //<-Los valores que llegan (es como el valor actual con el que se guardo el courso)
                      // editingOptions={initialValues.campus} //<-Los valores que llegan <- este en todos los valores que tenga
                      // editingOptions={[]} //<-Los valores que llegan <- este lo sete en []
                    />

                    <div className="error-message-form">
                      <ErrorMessage name="campus" />
                    </div>
                  </div>

                  <Input
                    name="material"
                    type="number"
                    label="Material (AUD):"
                    isModal={true}
                  />
                  <Input
                    name="tuitionfee"
                    type="number"
                    label="Tuition Fee (AUD):"
                    isModal={true}
                  />
                  <Input
                    name="applicationfee"
                    type="number"
                    label="Application Fee (AUD):"
                    isModal={true}
                  />

                  <div>
                    {loading ? (
                      <LoaderDots />
                    ) : (
                      <button className="btn-save" type="submit">
                        Update Course
                      </button>
                    )}
                  </div>
                </Form>
              </div>

              <div className="alert-container">
                {msgAlert && (
                  <AlertPopUp msg={`${msgAlert.msg}`} type={msgAlert.type} />
                )}
              </div>
            </div>
          );
        }}
      </Formik>
    </div>
  );
};

export default CourseFormModal;
